import { render, staticRenderFns } from "./tradingRow.vue?vue&type=template&id=87465934&scoped=true&"
import script from "./tradingRow.vue?vue&type=script&lang=js&"
export * from "./tradingRow.vue?vue&type=script&lang=js&"
import style0 from "./tradingRow.vue?vue&type=style&index=0&id=87465934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87465934",
  null
  
)

export default component.exports